import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { SelectInputItemProps } from "models/propTypes/wintFormPropsTypes";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region  components
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateReceiptDraftFormHelpers() {
  const companyReceiptCategories = useSelector((store: AppState) => store.auth.selectedCompany.receiptCategories);
  const companyId = useSelector((store: AppState) => store.auth.selectedCompany.id);

  const storeReceiptPaymentMethods = useSelector(
    (x: AppState) => x.auth.loggedInUser.wintCardPaymentMethods,
    (left, right) => left.map((l) => l.id).join("") === right.map((r) => r.id).join("")
  );

  const wintCardPaymentMenthods: SelectInputItemProps[] = React.useMemo(() => {
    return (
      storeReceiptPaymentMethods
        ?.filter(
          (p) =>
            p.isActive &&
            p.type === WintSuperkollAPIModel.ReceiptPaymentMethodType.WintCard &&
            p.companyId === companyId
        )
        ?.map((p) => ({
          value: p.id,
          label: p.name ?? "",
          data: p,
          group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
        })) ?? []
    );
  }, [storeReceiptPaymentMethods, companyId]);

  const skipCategories = [
    WintSuperkollAPIModel.ReceiptCategoryType.Other,
    WintSuperkollAPIModel.ReceiptCategoryType.Representation,
    WintSuperkollAPIModel.ReceiptCategoryType.EmployeeRepresentation,
  ];

  const receiptCategories: AutocompleteListItem[] = React.useMemo(() => {
    return (
      companyReceiptCategories
        ?.filter(
          (cat) => cat.categoryType === undefined || (cat.categoryType && !skipCategories.includes(cat.categoryType))
        )
        ?.map((item) => ({
          id: item.id,
          value: item.name ?? " ",
          data: item,
          group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
        })) ?? []
    );
  }, [companyReceiptCategories]);

  const suggestionsCategories = [
    WintSuperkollAPIModel.ReceiptCategoryType.ITServiceOrSoftware,
    WintSuperkollAPIModel.ReceiptCategoryType.PurchasesOfGoods,
    WintSuperkollAPIModel.ReceiptCategoryType.Fuel,
  ]; // TODO: Change these once gets the proper category types

  const receiptCategorySuggestions: SelectionItem[] =
    receiptCategories
      ?.filter((cat) => cat.data && suggestionsCategories.includes(cat.data.categoryType))
      .map((item) => item as SelectionItem) ?? [];

  return {
    receiptCategories,
    wintCardPaymentMenthods,
    receiptCategorySuggestions,
  };
}

export default useCreateReceiptDraftFormHelpers;
